function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgEditIcon(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "M1.42 18.579a1 1 0 01-.737-.326.988.988 0 01-.263-.764l.245-2.694L11.983 3.48l3.537 3.536L4.205 18.33l-2.694.245a.95.95 0 01-.091.004zm14.806-12.27L12.69 2.775 14.811.653a1 1 0 011.415 0l2.121 2.12a1 1 0 010 1.416l-2.12 2.12h-.001z",
    fill: props.fill
  }));
}

export default SvgEditIcon;